import {
    Box,
    Typography,
    Tooltip,
    IconButton,
} from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import styles from './styles.module.scss'

const PageLink = (props) => {
    const { link } = props;

    const handleOpenLink = () => {
        if (!link) return;
        window.open(link, '_blank', 'noopener,noreferrer')
    }

    if(!link) return null;

    return (
        <Box className={styles.container}>
            <Typography variant="body1" color="primary" sx={{fontWeight: 500}}>
                URL:&nbsp;
            </Typography>
            <Typography
                className={styles.link}
                variant="body1"
                color="secondary"
                onClick={handleOpenLink}
            >
                {link}
            </Typography>
            <Tooltip
                title="Open in a new tab"
                PopperProps={{
                    sx: {
                        "& .MuiTooltip-tooltip": {
                            backgroundColor: "primary.main",
                        },
                    },
                }}
            >
                <IconButton className={styles.iconButton} onClick={handleOpenLink}>
                    <OpenInNewIcon color="primary" />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export default PageLink;